module.exports = __webpack_public_path__ + "img/next.0f40c185.svg";